export default __webpack_public_path__ + "static/area-guid_img_m-15b7a3b1755e214e9f17e413124401b7.jpg";